/**
 * Contact Form Success Tracker
 * Tracks form submission and retrieves data on successful submit
 */

(function() {
  const CONFIG = {
    storageKey: 'contactFormData',
    maxAge: 10000,
    checkDelay: 600,
    gtagMaxWait: 10000,
    gtagCheckInterval: 100,
    googleAdsId: 'AW-16510068136'
  };
  
  // ========================================
  // PART 0: Initialize Google Ads if needed
  // ========================================
  
  function initGoogleAds() {
    const existingScript = document.querySelector(`script[src*="googletagmanager.com/gtag/js"]`);
    
    if (existingScript) {
      return;
    }
    
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${CONFIG.googleAdsId}`;
    document.head.appendChild(script);
    
    window.dataLayer = window.dataLayer || [];
    window.gtag = function() {
      window.dataLayer.push(arguments);
    };
    
    gtag('js', new Date());
    gtag('config', CONFIG.googleAdsId);
  }
  
  // ========================================
  // PART 1: Capture form data before submit
  // ========================================
  
  function captureFormData() {
    const form = document.getElementById('contact_form');
    if (!form) return;
    
    form.addEventListener('submit', function() {
      if (form.checkValidity()) {
        const data = extractFormData(form);
        saveToStorage(data);
      }
    });
  }
  
  function extractFormData(form) {
    return {
      name: form.querySelector('[name="contact[name]"]')?.value || '',
      email: form.querySelector('[name="contact[email]"]')?.value || '',
      phone: form.querySelector('[name="contact[phone]"]')?.value || '',
      message: form.querySelector('[name="contact[body]"]')?.value || '',
      timestamp: Date.now()
    };
  }
  
  function saveToStorage(data) {
    try {
      sessionStorage.setItem(CONFIG.storageKey, JSON.stringify(data));
    } catch (e) {
      // Silent fail
    }
  }
  
  // ========================================
  // PART 2: Check success after page reload
  // ========================================
  
  function checkSubmissionSuccess() {
    const savedData = getStoredData();
    if (!savedData) return;
    
    const age = Date.now() - savedData.timestamp;
    if (age > CONFIG.maxAge) {
      clearStorage();
      return;
    }
    
    setTimeout(() => {
      if (isSubmissionSuccessful()) {
        handleSuccess(savedData);
        clearStorage();
      }
    }, CONFIG.checkDelay);
  }
  
  function getStoredData() {
    try {
      const data = sessionStorage.getItem(CONFIG.storageKey);
      return data ? JSON.parse(data) : null;
    } catch (e) {
      return null;
    }
  }
  
  function isSubmissionSuccessful() {
    const successElement = document.querySelector('.ai-contact-success-asstwb0rqull4wwtomaigenblock64907b6ae7qvd');
    if (successElement && isVisible(successElement)) {
      return true;
    }
    
    const url = window.location.href;
    if (url.includes('contact_posted=true') || 
        url.includes('customer_posted=true') ||
        (url.includes('#contact_form') && successElement)) {
      return true;
    }
    
    return false;
  }
  
  function isVisible(element) {
    if (!element) return false;
    const style = window.getComputedStyle(element);
    return style.display !== 'none' && 
           style.visibility !== 'hidden' && 
           element.offsetHeight > 0;
  }
  
  function clearStorage() {
    sessionStorage.removeItem(CONFIG.storageKey);
  }
  
  // ========================================
  // PART 3: Handle successful submission
  // ========================================
  
  function handleSuccess(formData) {
    window.dispatchEvent(new CustomEvent('contactFormSuccess', {
      detail: formData
    }));
    
    sendGoogleAdsConversion(formData);
  }
  
  function waitForGtag() {
    return new Promise((resolve, reject) => {
      if (typeof window.gtag === 'function' && window.dataLayer) {
        resolve();
        return;
      }
      
      let elapsedTime = 0;
      const interval = setInterval(() => {
        elapsedTime += CONFIG.gtagCheckInterval;
        
        if (typeof window.gtag === 'function' && window.dataLayer) {
          clearInterval(interval);
          resolve();
          return;
        }
        
        if (elapsedTime >= CONFIG.gtagMaxWait) {
          clearInterval(interval);
          reject(new Error('gtag timeout'));
        }
      }, CONFIG.gtagCheckInterval);
    });
  }
  
  async function sendGoogleAdsConversion(formData) {
    try {
      await waitForGtag();
      
      gtag('event', 'conversion', {
        'send_to': 'AW-16510068136/5TjmCIfa0-4bEKjLzsA9',
        'event_callback': function() {
          window.dispatchEvent(new CustomEvent('googleAdsConversionSuccess', {
            detail: {
              formData: formData,
              conversionId: 'AW-16510068136/5TjmCIfa0-4bEKjLzsA9',
              timestamp: Date.now()
            }
          }));
        },
        'event_timeout': 2000
      });
      
    } catch (error) {
      window.dispatchEvent(new CustomEvent('googleAdsConversionError', {
        detail: {
          error: error.message,
          formData: formData
        }
      }));
    }
  }
  
  // ========================================
  // Initialize
  // ========================================
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  function init() {
    initGoogleAds();
    captureFormData();
    checkSubmissionSuccess();
  }
  
})();

// ========================================
// USAGE: Listen to the success events
// ========================================

window.addEventListener('contactFormSuccess', function(event) {
  const data = event.detail;
  // Form submitted successfully
});

window.addEventListener('googleAdsConversionSuccess', function(event) {
  const data = event.detail;
  // Google Ads conversion sent successfully
  // You can add your own tracking here
});

window.addEventListener('googleAdsConversionError', function(event) {
  const data = event.detail;
  // Google Ads conversion failed
  // You can add error handling here
});